export const STATUS_NOT_EXPORTED = "NOT_EXPORTED";
export const STATUS_PENDING = "PENDING";
export const STATUS_IN_PROGRESS = "IN_PROGRESS";
export const STATUS_DONE = "DONE";
export const STATUS_ERROR = "ERROR";
export const FULL_MAP = "FULL_MAP";
export const CURRENT_VIEW = "CURRENT_VIEW";
export const FULL_MAP_SELECTED_KPIS = "FULL_MAP_SELECTED_KPIS";

export const FORMAT_CSV = "csv";
export const FORMAT_XLSX = "xlsx";
export const FORMAT_PDF = "pdf";

export const COLOR_NEUTRAL = "#D9D9D9";
export const COLOR_POSITIVE = "#107F47";
export const COLOR_ERROR = "#D91734";

export const MODULE_CUSTOMER = "customer";
export const MODULE_ORDER = "order";

export const MODULE_LOS = "los";
export const MODULE_EDLOS = "los";
export const MODULE_BIRTHDAYS_AR = "birthdaysAr";
export const MODULE_BIRTHDAYS_V2 = "birthdaysV2";
export const MODULE_BIRTHDAYS_V2_EXPORT_NAME = "Birthday";
export const MODULE_GOALS_AR = "goalsAr";
export const MODULE_PROVISIONAL_AR = "provisionalAr";
export const MODULE_CBR_AR = "cbrAr";
export const MODULE_CVR_AR = "cvrAr";
export const MODULE_CVR_V2 = "cvrV2";
export const MODULE_CVR_V2_EXPORT_NAME = "CVR_Compliance";
export const MODULE_WATCHLIST = "watchlist";
export const MODULE_WATCHLIST_EXPORT_NAME = "Watchlist";
export const MODULE_WHOSNEW = "whosNew";
export const MODULE_WHOS_NEW_V2 = "whosNewV2";
export const MODULE_WHOS_NEW_V2_EXPORT_NAME = "Who's_New";
export const MODULE_WHOS_CLOSE = "whosClose";
export const MODULE_WHOS_CLOSE_V2 = "whosCloseV2";
export const MODULE_WHOS_CLOSE_V2_EXPORT_NAME = "Who's_Close";
export const MODULE_NON_BONUSABLE_BV_AR = "nonBonusableBvAr";
export const MODULE_NON_BONUSABLE_BV_V2 = "nonBonusableBvV2";
export const MODULE_NON_BONUSABLE_BV_V2_EXPORT_NAME = "Non-Bonusable_BV";
export const MODULE_CBR_V2 = "cbrV2";
export const MODULE_CBR_V2_EXPORT_NAME = "CBR_Clock";
export const MODULE_RENEWALS = "renewalsAr";
export const MODULE_RENEWALS_V2_EXPORT_NAME = "Renewal";

export const MODULE_SSI_UPLINE = "ssiUpline";
export const MODULE_SAQ = "saq";
export const MODULE_SAQ_EXPORT_NAME = "SAQ_Certification";
export const MODULE_FSI_ACTION_REPORT = "fsiActionReport";
export const MODULE_FSI_ACTION_REPORT_IN_FSI = "In_FSI_Program";
export const MODULE_FSI_ACTION_REPORT_OUT_FSI = "Out_FSI_Program";
export const MODULE_SSI_UPLINE_IN_WINDOW = "SSI_IN_WINDOW";
export const MODULE_SSI_UPLINE_PRE_WINDOW = "SSI_PRE_WINDOW";
export const MODULE_SSI_UPLINE_OUT_OF_PROGRAM = "SSI_OUT_OF_PROGRAM";
export const MODULE_SSI_UPLINE_EARNED_PAYMENT = "SSI_EARNED_PAYMENT";

export const MODULE_RENEWALS_IN_RENEWAL_PERIOD = "RENEWALS_IN_RENEWAL_PERIOD";
export const MODULE_RENEWALS_IN_GRACE_PERIOD = "RENEWALS_IN_GRACE_PERIOD";
export const MODULE_RENEWALS_NOT_ON_AUTO_RENEWAL = "RENEWALS_NOT_ON_AUTO_RENEWAL";
export const MODULE_RENEWALS_ON_AUTO_RENEWAL = "RENEWALS_ON_AUTO_RENEWAL";
export const MODULE_RENEWALS_EARLY_RENEWAL_PERIOD = "RENEWALS_EARLY_RENEWAL_PERIOD";

export const EXPORT_FILE_NAME_SUFFIX: Record<string, string> = {
  [MODULE_BIRTHDAYS_V2]: MODULE_BIRTHDAYS_V2_EXPORT_NAME,
  [MODULE_WHOS_CLOSE_V2]: MODULE_WHOS_CLOSE_V2_EXPORT_NAME,
  [MODULE_WHOS_NEW_V2]: MODULE_WHOS_NEW_V2_EXPORT_NAME,
  [MODULE_NON_BONUSABLE_BV_V2]: MODULE_NON_BONUSABLE_BV_V2_EXPORT_NAME,
  [MODULE_RENEWALS]: MODULE_RENEWALS_V2_EXPORT_NAME,
  [MODULE_CVR_V2]: MODULE_CVR_V2_EXPORT_NAME,
  [MODULE_CBR_V2]: MODULE_CBR_V2_EXPORT_NAME,
  [MODULE_WATCHLIST]: MODULE_WATCHLIST_EXPORT_NAME,
};

export type ExportFormat = typeof FORMAT_XLSX | typeof FORMAT_CSV | typeof FORMAT_PDF;

/**
 * Maps UI KPI keys to their corresponding export field IDs.
 * Used to align table column labels with export file column headers.
 *
 * Note: Multiple KPI keys can map to the same export field ID (e.g. "sponsoring" and
 * "totalNewABOCount" both → "totalNewABOCount"). This is intentional — different reports
 * use different key names for the same underlying data, but each report's uiKpis config
 * only ever includes one alias, so duplicates cannot occur within a single export.
 */
export const EXPORT_FIELD_ID_BY_KPI: Record<string, string> = {
  ppv: "personalPV",
  personalPV: "personalPV",
  groupPVNeeded: "groupPVNeeded",
  ppvRequirement: "ppvARRequirement",
  ppvYtd: "personalPVYtd",
  groupPV: "groupPV",
  customers: "totalCustomerCount",
  totalCustomerCount: "totalCustomerCount",
  totalABOCount: "totalABOCount",
  totalNewABOCount: "totalNewABOCount",
  sponsoring: "totalNewABOCount",
  sponsoringYtd: "newABOCountYtd",
  sponsoringYtdStar: "newABOCountYtd",
  sponsorName: "sponsorName",
  autoRenewal: "autoRenewal",
  frontlines: "frontlines",
  annualPPV: "annualPPV",
  renewalDate: "renewalDate",
  birthDate: "birthdate",
  bonusPercent: "bonusPercent",
  groupBV: "groupBV",
  qualifiedLegs: "qualifiedLegs",
  customerPV: "customerPV",
  rubyPV: "rubyPV",
  personalOrdersCount: "personalOrdersCount",
  groupOrdersCount: "groupOrdersCount",
  vcsPV: "vcsPV",
  nonVCSPV: "nonVCSPV",
  personalVcsPercent: "personalVcsPercent",
  nonBonusableBV: "nonBonusableBV",
  isFirstContractYear: "isFirstContractYear",
  cbrPeriodRemaining: "cbrPeriodRemaining",
  cbrVcsPercent: "cbrVcsPercent",
  cbrStartMonth: "cbrStartMonth",
  cbrEndMonth: "cbrEndMonth",
  saqStatus: "saqCompleted",
  expirationDate: "saqDueDate",
  upForRenewal: "saqUpForRenewal",
  groupSize: "totalABOCount",
  // FSI (Frontline Sales Incentive) Action Report
  ppvActual: "fsiPpvActual",
  ppvNeeded: "fsiPpvNeeded",
  vcsPvActual: "fsiVcsPvActual",
  vcsPvNeeded: "fsiVcsPvNeeded",
  vcsPercent: "fsiVcsPercentActual",
  accumulatedVcsBv: "fsiAccumulatedVcsBv",
  exitMonth: "fsiExitMonth",
};

/** Base fields included in every export (name, ABO number, contact info, etc.) */
export const BASE_EXPORT_FIELD_IDS = [
  "sponsorABONo",
  "name",
  "aboNo",
  "countryCode",
  "entryDate",
  "phone",
  "email",
  "address",
];
